import AES from "@/mixins/AES";

function findMenuItem(list, value) {
  for (const item of list) {
    if (item.menuPath === value) {
      return item;
    }
    if (item.children && item.children.length > 0) {
      const result = findMenuItem(item.children, value);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

function judgeButtonPermission(value) {
  let menuList = JSON.parse(
    AES.decrypt(window.localStorage.getItem("menuListData"))
  );
  const menuItem = findMenuItem(menuList, value);
  if (menuItem) {
    return true;
  }
  return false;
}

const hasPermission = {
  install(Vue) {
    Vue.directive("hasPermission", {
      inserted(el, binding) {
        const { value } = binding;

        // 检查 value 是字符串且不为空
        if (typeof value === "string" && value.trim() !== "") {
          const hasPermission = judgeButtonPermission(value);
          if (!hasPermission) {
            el.style.display = "none";
          }
        } else {
          throw new Error(
            `需要传入权限标识! 例如：v-hasPermission="'permission1'"`
          );
        }
      },
      update(el, binding) {
        const { value } = binding;

        // 检查 value 是字符串且不为空
        if (typeof value === "string" && value.trim() !== "") {
          const hasPermission = judgeButtonPermission(value);
          el.style.display = hasPermission ? "" : "none";
        }
      },
    });
  },
};

export { hasPermission, judgeButtonPermission };
